import { gql } from '@apollo/client';
import { FR_SERVICE_AGREEMENT_FIELDS } from './service';

export const MACHINE_FIELDS_FRAGMENT = gql`
    fragment MachineFields on Machine {
        MachineId
        Name
        SerialNbr
        Created
        Updated
        InServiceDate
        OutOfServiceDate
        PurchaseVendor
        WarrantyExpirationDate
        PurchaseDate
        CalibrationDate
        ExpirationDate
        Organization {
            OrganizationId
            Name
            OrganizationStateType {
                OrganizationStateTypeId
            }
            Bin
        }
        MachineTaskType {
            MachineTaskTypeId
            TaskType {
                TaskTypeId
                Name
                Abbr
                TaskGroup
            }
        }
        MachineClass {
            Name
            MachineClassId
        }
        MachineType {
            Name
            MachineTypeId
        }
        MachineModel {
            MachineModelId
            Name
        }
        Asset {
            AssetName
            AssetType
        }
        Access {
            Read
            Create
            Delete
            Update
        }
        Width
        MaximumWidth
        MaximumHeight
        TransportHeight
        TransportLength
        MassFrontRight
        MassFrontLeft
        MassRearRight
        MassRearLeft
        TotalMass
    }
`;

export const FR_INSPECTION_LIST_MACHINE_FIELDS = gql`
    fragment fr_InspectionListMachineFields on Machine {
        MachineId
        Name
        SerialNbr
        Organization {
            OrganizationId
            Name
        }
        MachineType {
            Name
            MachineTypeId
        }
        Asset {
            AssetName
            AssetType
        }
    }
`;

export const FR_MACHINE_STATUS = gql`
    fragment fr_MachineStatus on Machine {
        MachineStatus {
            Battery
            AdBlue
            Fuel
            EngineRunningHours
            Updated
        }
    }
`;

export const FR_MACHINE_LATEST_SERVICE = gql`
    fragment fr_MachineLatestService on Machine {
        LatestService {
            Date
            Hours
            Cycle
        }
    }
`;

export const FR_MACHINE_OPEN_ISSUE_COUNT = gql`
    fragment fr_MachineOpenIssueCount on Machine {
        IssueCount(data: { Status: [ISSUE_OPEN] })
    }
`;

export const FR_MACHINE_LATEST_INSPECTION = gql`
    fragment fr_MachineLatestInspection on Machine {
        LatestInspection {
            Date
            Hours
            Cycle
            SuccessCount
            FailureCount
            TaskCount
        }
    }
`;

export const FR_MACHINE_NEXT_SERVICE = gql`
    fragment fr_MachineNextService on Machine {
        NextService {
            EstimateDate
            EstimateHours
            NextCycle
        }
    }
`;

export const FR_FLEET_FIELDS = gql`
    fragment fr_FleetFields on Machine {
        MachineId
        Name
        SerialNbr
        Width
        MaximumWidth
        MaximumHeight
        TransportHeight
        TransportLength
        MassFrontRight
        MassFrontLeft
        MassRearRight
        MassRearLeft
        TotalMass
        Created
        Updated
        PurchaseVendor
        PurchaseDate
        WarrantyExpirationDate
        OutOfServiceDate
        InServiceDate
        OperationHours {
            MachineMetricId
            Max
            Latest
            Date
            Source
        }
        ServiceAgreement {
            ...fr_ServiceAgreementFields
        }
        MachineClass {
            MachineClassId
            Name
        }
        MachineType {
            MachineTypeId
            Name
        }
        MachineModel {
            MachineModelId
            Name
        }
        Organization {
            OrganizationId
            Name
        }
        PurchaseDate
        PurchaseVendor
        Access {
            Create
            Delete
            Read
            Update
        }
        MachineTaskType {
            MachineTaskTypeId
            TaskType {
                TaskTypeId
                Name
                Abbr
                TaskGroup
            }
        }
        ...fr_MachineStatus
        ...fr_MachineNextService
        ...fr_MachineLatestService
        ...fr_MachineLatestInspection
        ...fr_MachineOpenIssueCount
    }
    ${FR_SERVICE_AGREEMENT_FIELDS}
    ${FR_MACHINE_STATUS}
    ${FR_MACHINE_NEXT_SERVICE}
    ${FR_MACHINE_LATEST_SERVICE}
    ${FR_MACHINE_LATEST_INSPECTION}
    ${FR_MACHINE_OPEN_ISSUE_COUNT}
`;

export const FR_MACHINE_TYPE_FIELDS = gql`
    fragment fr_MachineTypeFields on MachineType {
        MachineTypeId
        Name
    }
`;
